__turbopack_context__.v({
  "accountState": "newsletter-module__EVDqwW__accountState",
  "byline": "newsletter-module__EVDqwW__byline",
  "closing": "newsletter-module__EVDqwW__closing",
  "consent": "newsletter-module__EVDqwW__consent",
  "cta": "newsletter-module__EVDqwW__cta",
  "dek": "newsletter-module__EVDqwW__dek",
  "embedded": "newsletter-module__EVDqwW__embedded",
  "formContent": "newsletter-module__EVDqwW__formContent",
  "founders": "newsletter-module__EVDqwW__founders",
  "foundersImage": "newsletter-module__EVDqwW__foundersImage",
  "headline": "newsletter-module__EVDqwW__headline",
  "hero": "newsletter-module__EVDqwW__hero",
  "input": "newsletter-module__EVDqwW__input",
  "inside": "newsletter-module__EVDqwW__inside",
  "intro": "newsletter-module__EVDqwW__intro",
  "letter": "newsletter-module__EVDqwW__letter",
  "letterImage": "newsletter-module__EVDqwW__letterImage",
  "number": "newsletter-module__EVDqwW__number",
  "page": "newsletter-module__EVDqwW__page",
  "questions": "newsletter-module__EVDqwW__questions",
  "reason": "newsletter-module__EVDqwW__reason",
  "sectionIntro": "newsletter-module__EVDqwW__sectionIntro",
  "sectionTitle": "newsletter-module__EVDqwW__sectionTitle",
  "signIn": "newsletter-module__EVDqwW__signIn",
  "signature": "newsletter-module__EVDqwW__signature",
  "signup": "newsletter-module__EVDqwW__signup",
  "signupIntro": "newsletter-module__EVDqwW__signupIntro",
  "signupPosition": "newsletter-module__EVDqwW__signupPosition",
  "submit": "newsletter-module__EVDqwW__submit",
  "success": "newsletter-module__EVDqwW__success",
  "textLink": "newsletter-module__EVDqwW__textLink",
  "trust": "newsletter-module__EVDqwW__trust",
  "trustInner": "newsletter-module__EVDqwW__trustInner",
});
